// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ih_a bhl_jk","CommentListPlaceholder--Legacy":"ih_b bhl_rc bhl_wq"};